import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';

const action = (
  state: IState,
  payloadAction: PayloadAction<{ id: number }>,
) => {
  const { id } = payloadAction.payload;
  state.activeFilter.id = id;
};

export default action;
